import { stringify } from 'querystring';

import { GroupSortOrder } from '@ms/yammer-graphql';

export const discoverGroupsUrl = '/discover-groups';
export const discoverGroupsRecommendedUrl = '/discover-groups/recommended';
export const discoverGroupsOfficialUrl = '/discover-groups/official';
export const discoverGroupsAllUrl = '/discover-groups/all';
export const discoverGroupsExploreUrl = '/discover-groups/explore';

export const discoverGroupsRootPath = '/discover-groups';
export const discoverGroupsRecommendedSubpath = '/recommended';
export const discoverGroupsOfficialSubpath = '/official';
export const discoverGroupsSearchSubpath = '/all-search';
export const discoverGroupsAllSubpath = '/all';

export type DiscoverGroupsAllSortByParameters = 'members' | 'name';
export const discoverGroupsAllPath: `${typeof discoverGroupsRootPath}${typeof discoverGroupsAllSubpath}` = `${discoverGroupsRootPath}${discoverGroupsAllSubpath}`;
export const discoverGroupsSearchPath: `${typeof discoverGroupsRootPath}${typeof discoverGroupsSearchSubpath}` = `${discoverGroupsRootPath}${discoverGroupsSearchSubpath}`;
type DiscoverGroupsAllUrlWithSortBy =
  `${typeof discoverGroupsAllUrl}?${typeof queryParamSortBy}=${DiscoverGroupsAllSortByParameters}`;
export const discoverGroupsAllPageWithParametersForTBE = (
  sortBy: DiscoverGroupsAllSortByParameters
): DiscoverGroupsAllUrlWithSortBy =>
  `${discoverGroupsAllUrl}?${queryParamSortBy}=${sortBy}` as DiscoverGroupsAllUrlWithSortBy;

export const queryParamSortBy = 'sortBy';

export enum GroupSortOrderCustom {
  RECOMMENDED = 'Recommended',
  OFFICIAL = 'Official',
}

export type AllTabGroupSortOrder = GroupSortOrder | GroupSortOrderCustom;

export const GroupSortQueryParam: Record<AllTabGroupSortOrder, string> = {
  [GroupSortOrderCustom.OFFICIAL]: 'official',
  [GroupSortOrderCustom.RECOMMENDED]: 'recommended',
  [GroupSortOrder.MEMBER_COUNT_DESC]: 'members',
  [GroupSortOrder.CREATION_DATE_DESC]: 'createdAt',
  [GroupSortOrder.NAME_ASC]: 'name',
};

type DiscoverGroupsAllPageWithParameters = (sortBy: AllTabGroupSortOrder) => string;

export const discoverGroupsAllPageWithParameters: DiscoverGroupsAllPageWithParameters = (sortBy) => {
  const sortByParam = { [queryParamSortBy]: GroupSortQueryParam[sortBy] };

  return `${discoverGroupsAllUrl}?${stringify(sortByParam)}`;
};
